import { useQuery } from '@tanstack/react-query';
import { v4 as uuidv4 } from 'uuid';

const BFF_BASE_URL = process.env.REACT_APP_BFF_BASE_URL

export async function submitFeedback(feedback: any, session: any) {
    const application = {
        type: 'web',
		version: process.env.REACT_APP_WEB_APP_VERSION || '1.0',
		build: process.env.REACT_APP_WEB_APP_BUILD || '1.0',
    }
    if(!session?.idToken || session?.expiryMs < Date.now()) {
        throw new Error('Session expired')
    }
    const res = await fetch(`${BFF_BASE_URL}/v1/feedback`,
        {
            method: 'POST',
            body: JSON.stringify({ feedback, application }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${session?.accessToken}`,
                'x-id': `${session?.idToken}`,
                'x-session-id': session?.sessionId || 'x-session-id',
                'x-correlation-id': uuidv4()
            }
        }
    );
    if (!res.ok) {
        throw new Error((await res.json()).message);
    }

    return "submitted"
}

export async function getFeedbackFlows(session: any) {
    if(!session?.accessToken || session?.expiryMs < Date.now()) {
        throw new Error('Session expired')
    }
    const res = await fetch(`${BFF_BASE_URL}/v1/feedback/flows`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${session?.accessToken}`,
                'x-id': `${session?.idToken}`,
                'x-session-id': session?.sessionId || 'x-session-id',
                'x-correlation-id': uuidv4()
            }
        }
    );
    if (!res.ok) {
        throw new Error((await res.json()).message);
    }

    return (await res.json())
}


export const useGetFeedbackFlows= (session: any) => {
    const {error:errorFeedback, data: feedbackFlows } = useQuery( {
        queryKey: ['FeedbackFlows'], // key must be unique
        queryFn: ()=>getFeedbackFlows(session),
        staleTime: (60000 * 60)
    })

    return { errorFeedback, feedbackFlows }
  };
  

